<template>
  <div class="group items-center py-6">
    <SessionItemIcon :platform="getOS(item.user_agent)"/>
    <div>
      <div class="text-text-ternary text-xs mb-2"> {{ getOS(item.user_agent) }}</div>
      <SessionItemName :name="item.name"
                       class="text-sm"
                       @change="$emit('changeName',{...$event,id:item.id})"/>
    </div>
    <div>
      <div class="text-text-ternary text-xs mb-2">
        {{ $moment.unix(item.used_at).locale($i18n.locale).format('HH:MM') }}
      </div>
      <div class="text-secondary text-sm">
        {{ $moment.unix(item.used_at).locale($i18n.locale).format('DD.MM.YYYY') }}
      </div>
    </div>
    <div>
      <div class="text-text-ternary text-xs mb-2">
        {{ $moment.unix(item.created_at).locale($i18n.locale).format('HH:MM') }}
      </div>
      <div class="text-secondary text-sm">
        {{ $moment.unix(item.created_at).locale($i18n.locale).format('DD.MM.YYYY') }}
      </div>
    </div>
    <SessionItemGeo :ip="item.ip"
                    :countryCode="item.country_code"
                    :city="item.city"
                    :country="item.country_name"/>
    <div class="flex items-center">
      <div class="ml-auto flex items-center">
        <div v-if="item.is_current" class="w-3-3 h-3-3 bg-green-hover rounded-full"></div>
        <IconTrash v-tooltip="$t('removeTooltip')" @click.native="$emit('delete',item.id)"
                   class="ml-4 -mr-1 cursor-pointer text-icon hover:text-icon-hover opacity-0 focus:outline-none
                   transition duration-200 group-hover:opacity-100"/>

      </div>
    </div>
  </div>
</template>

<script>
import SessionItemName from "@/components/cabinet/ProfileSettings/Sessions/SessionItem/SessionItemName";
import SessionItemGeo from "@/components/cabinet/ProfileSettings/Sessions/SessionItem/SessionItemGeo";
import SessionItemIcon from "@/components/cabinet/ProfileSettings/Sessions/SessionItem/SessionItemIcon";
import IconTrash from "@/components/icons/IconTrash";

export default {
  name: "SessionItem",
  props: ['item'],
  components: {IconTrash, SessionItemName, SessionItemGeo, SessionItemIcon},
  methods: {
    getOS(user_agent) {
      if (!user_agent) return "Unknown"
      let OSName = "Unknown";
      if (user_agent.indexOf("Windows NT 10.0") != -1) OSName = "Windows 10";
      if (user_agent.indexOf("Windows NT 6.2") != -1) OSName = "Windows 8";
      if (user_agent.indexOf("Windows NT 6.1") != -1) OSName = "Windows 7";
      if (user_agent.indexOf("Windows NT 6.0") != -1) OSName = "Windows Vista";
      if (user_agent.indexOf("Windows NT 5.1") != -1) OSName = "Windows XP";
      if (user_agent.indexOf("Windows NT 5.0") != -1) OSName = "Windows 2000";
      if (user_agent.indexOf("Mac") != -1) OSName = "Mac OS";
      if (user_agent.indexOf("X11") != -1) OSName = "UNIX";
      if (user_agent.indexOf("Linux") != -1) OSName = "Linux";

      if (user_agent.indexOf("Android") != -1) OSName = "Android OS";
      if (user_agent.indexOf("like Mac") != -1) OSName = "iOS";

      //mobile apps
      if (user_agent.indexOf("ios_app") != -1) OSName = "iOS App";
      if (user_agent.indexOf("android_app") != -1) OSName = "Android App";

      return OSName
    }
  },
  i18n: {
    messages: {
      en: {
        removeTooltip: 'Delete session'
      },
      ru: {
        removeTooltip: 'Удалить сессию'
      }
    }
  }
}
</script>